import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-5b34fad0")

_pushScopeId("data-v-5b34fad0")
const _hoisted_1 = { class: "logo" }
const _hoisted_2 = { class: "center title-1" }
const _hoisted_3 = { class: "buttons-container" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("img", {
        height: "100",
        src: $setup.storeProject.getters[$setup.StoreGettersProject.LOGO],
        alt: $setup.t('Images.logoNav')
      }, null, 8, ["src", "alt"])
    ]),
    _createVNode("dig-ui-title", _hoisted_2, _toDisplayString($setup.t('welcome', { name: $setup.name })), 1),
    _createVNode("div", _hoisted_3, [
      _createVNode("dig-ui-standard-button", {
        onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.goTo('/new-simulation')))
      }, _toDisplayString($setup.t('Home.simulation')), 1),
      _createVNode("dig-ui-standard-button", {
        onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.goTo('/dossiers')))
      }, _toDisplayString($setup.t('Home.simulations')), 1),
      ($setup.isAdmin)
        ? (_openBlock(), _createBlock("dig-ui-standard-button", {
            key: 0,
            onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.goTo('/users')))
          }, _toDisplayString($setup.t('Home.users')), 1))
        : _createCommentVNode("", true),
      ($setup.isAdmin)
        ? (_openBlock(), _createBlock("dig-ui-standard-button", {
            key: 1,
            onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.goTo('/project')))
          }, _toDisplayString($setup.t('Home.project')), 1))
        : _createCommentVNode("", true)
    ])
  ], 64))
})